/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  LedgerDepositOptions,
  LedgerDepositStatus201,
  LedgerDepositStatus400,
  LedgerDepositStatus403,
  LedgerDepositStatus500,
} from '../types/LedgerDeposit'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { ledgerDeposit } from '../clients/ledgerDeposit'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const ledgerDepositMutationKey = () => [{ url: '/v1/ledger/deposit/:user_id' }] as const

export function ledgerDepositMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = ledgerDepositMutationKey()
  return mutationOptions<
    LedgerDepositStatus201,
    ResponseErrorConfig<LedgerDepositStatus400 | LedgerDepositStatus403 | LedgerDepositStatus500>,
    LedgerDepositOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return ledgerDeposit({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Deposit assets into this user's account from the outside world. Note that this does not interact with any external systems; it simply adds the amount to the user's available balance in the ledger. Actual transfer of assets must be handled separately.
 * @summary Deposit assets into this user's account from the outside world
 * {@link /v1/ledger/deposit/:user_id}
 */
export function useLedgerDeposit<TContext>(
  options: {
    mutation?: UseMutationOptions<
      LedgerDepositStatus201,
      ResponseErrorConfig<LedgerDepositStatus400 | LedgerDepositStatus403 | LedgerDepositStatus500>,
      LedgerDepositOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? ledgerDepositMutationKey()

  const baseOptions = ledgerDepositMutationOptions(config) as UseMutationOptions<
    LedgerDepositStatus201,
    ResponseErrorConfig<LedgerDepositStatus400 | LedgerDepositStatus403 | LedgerDepositStatus500>,
    LedgerDepositOptions,
    TContext
  >

  return useMutation<
    LedgerDepositStatus201,
    ResponseErrorConfig<LedgerDepositStatus400 | LedgerDepositStatus403 | LedgerDepositStatus500>,
    LedgerDepositOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    LedgerDepositStatus201,
    ResponseErrorConfig<LedgerDepositStatus400 | LedgerDepositStatus403 | LedgerDepositStatus500>,
    LedgerDepositOptions,
    TContext
  >
}
